import API_ROUTES from "../constants/api";
import HttpUtil from "../http-handler/http-util";

export default class DocumentRuleService {
  static getList(regulationId) {
    var url = (API_ROUTES.DOCUMENTRULES.GENERAL).replace("<regulationId>", regulationId);
    return HttpUtil.get(url);
  }

  static saveData(regulationId,body) {
    let url = (API_ROUTES.DOCUMENTRULES.GENERAL).replace("<regulationId>", regulationId);
    if(body.id!==undefined && body.id!=null && body.id!=='') {
      url = url + `/${body.id}`;
      return HttpUtil.put(url,body)
    } else {
      return HttpUtil.post(url,body)
    }
   
  }

  static deleteData(regulationId,ruleId) {
    var url = (API_ROUTES.DOCUMENTRULES.GENERAL).replace("<regulationId>", regulationId)+`/${ruleId}`;
    return HttpUtil.delete(url);
  }
}
